import { http, HttpResponse } from "msw";
import { PlessService } from "src/app/shared/pless-service.model";

let isUpdated = false;

export const kymw1422Handlers = [
  http.post(PlessService.SERVICE.getParentChildPage.url, () => {
    return HttpResponse.json(getParentChildPage);
  }),
  http.post(PlessService.SERVICE.updateParentChildDiv.url, () => {
    // getPageで更新後の値を取得するため
    isUpdated = true;
    return HttpResponse.json({ status: 'ok', message: '処理完了' });
  }),
  http.post<unknown, { data: { parameter: { KomaID: number; }; }; }>(
    PlessService.SERVICE.KYMW14getKoma.url,
    async ({ request }) => {
      const komaId = (await request.json()).data.parameter.KomaID;
      return HttpResponse.json(getKoma(komaId));
    }),
  http.post<unknown, { data: { parameter: { PageID: number; }; }; }>(
    PlessService.SERVICE.KYMW14getPage.url,
    async ({ request }) => {
      const pageId = (await request.json()).data.parameter.PageID;
      return HttpResponse.json(getPage(pageId));
    }
  )
];


const getParentChildPage = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      WPublishGoods: [
        {
          PCode: "P2649007",
          GuideGoodsName: '新潟コシヒカリ',
          GuideStandardName: '５ｋｇ',
          WPublishPages: [
            {
              PageNum: 1,
              PageInfo: "表紙：新米特集",
              KomaID: '43983738',
              ParentChildDiv: "0"
            },
            {
              PageNum: 2,
              PageInfo: "特集　歳時　ごはんのおとも＆ごはんにあうおかず",
              KomaID: '43983808',
              ParentChildDiv: "1"
            },
            {
              PageNum: 2,
              PageInfo: "特集　歳時　ごはんのおとも＆ごはんにあうおかず",
              KomaID: '43983808',
              ParentChildDiv: "1"
            },
            {
              PageNum: 2,
              PageInfo: "特集　歳時　ごはんのおとも＆ごはんにあうおかず",
              KomaID: '43983808',
              ParentChildDiv: "1"
            },
            {
              PageNum: 2,
              PageInfo: "特集　歳時　ごはんのおとも＆ごはんにあうおかず",
              KomaID: '43983808',
              ParentChildDiv: "1"
            },
            {
              PageNum: 2,
              PageInfo: "特集　歳時　ごはんのおとも＆ごはんにあうおかず",
              KomaID: '43983808',
              ParentChildDiv: "1"
            },
            {
              PageNum: 2,
              PageInfo: "特集　歳時　ごはんのおとも＆ごはんにあうおかず",
              KomaID: '43983808',
              ParentChildDiv: "1"
            },
            {
              PageNum: 2,
              PageInfo: "特集　歳時　ごはんのおとも＆ごはんにあうおかず",
              KomaID: '43983808',
              ParentChildDiv: "1"
            },
            {
              PageNum: 2,
              PageInfo: "特集　歳時　ごはんのおとも＆ごはんにあうおかず",
              KomaID: '43983808',
              ParentChildDiv: "1"
            },
            {
              PageNum: 2,
              PageInfo: "特集　歳時　ごはんのおとも＆ごはんにあうおかず",
              KomaID: '43983808',
              ParentChildDiv: "1"
            },
            {
              PageNum: 2,
              PageInfo: "特集　歳時　ごはんのおとも＆ごはんにあうおかず",
              KomaID: '43983808',
              ParentChildDiv: "1"
            },
            {
              PageNum: 2,
              PageInfo: "特集　歳時　ごはんのおとも＆ごはんにあうおかず",
              KomaID: '43983808',
              ParentChildDiv: "1"
            },
            {
              PageNum: 2,
              PageInfo: "特集　歳時　ごはんのおとも＆ごはんにあうおかず",
              KomaID: '43983808',
              ParentChildDiv: "1"
            },
          ]
        },
        {
          PCode: "P1390899",
          GuideGoodsName: '秋田あきたこまち',
          GuideStandardName: '５ｋｇ',
          WPublishPages: [
            {
              PageNum: 1,
              PageInfo: "表紙：新米特集",
              KomaID: '43983738',
              ParentChildDiv: "0"
            },
            {
              PageNum: 2,
              PageInfo: "特集　歳時　ごはんのおとも＆ごはんにあうおかず",
              KomaID: '43983808',
              ParentChildDiv: "1"
            },
          ]
        }
      ]
    }
  }

};

const getKoma = (komaId: number) => {
  if (komaId === 43983738) {
    return {
      "status": "ok",
      "message": "処理完了",
      "result": {
        "obj": [
          {
            "KomaID": 43983738,
            "PositionX": 0.6,
            "PositionY": 0.0,
            "SizeW": 0.3,
            "SizeH": 0.214285714,
            "PromotionName": "",
            "LayoutInfo": [
              {
                "MultiPublishString": "Ｗ子",
                "OrderNumSeqNo": 30,
                "Priority": 1,
                "GuideGoodsName": "新潟コシヒカリ",
                "GuideStandardName": "５ｋｇ",
                "MakerName": "ＪＡ新潟かがやき・えちご中越産",
                "ThisTimeSupplyPrice": 1980,
                "OrderNum": "",
                "PricePattern": "2",
                "EdlpDiv": "0",
                "ReceiptSOrderCode": "",
                "StartOrderCode": "",
                "OrderNum6Digits": "",
                "ItemCode": "",
                "OrderGoodsFlg": "01",
                "PCode": "P1393391"
              }, {
                "MultiPublishString": "Ｗ子",
                "OrderNumSeqNo": 50,
                "Priority": 2,
                "GuideGoodsName": "秋田あきたこまち",
                "GuideStandardName": "５ｋｇ",
                "MakerName": "ＪＡ秋田おばこ・秋田なまはげ産",
                "ThisTimeSupplyPrice": 1680,
                "OrderNum": "",
                "PricePattern": "2",
                "EdlpDiv": "0",
                "ReceiptSOrderCode": "",
                "StartOrderCode": "",
                "OrderNum6Digits": "",
                "ItemCode": "",
                "OrderGoodsFlg": "01",
                "PCode": "P1390899"
              }
            ],
            "ImageInfo": [
              {
                "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_612/P1393391A_10.png?20250226111236",
                "ShowSeq": 1
              }
            ]
          },
        ]
      }
    };
  }
  if (komaId === 43983808) {
    return {
      "status": "ok",
      "message": "処理完了",
      "result": {
        "obj": [{
          "KomaID": 43983808,
          "PositionX": 0.5,
          "PositionY": 0.0,
          "SizeW": 0.25,
          "SizeH": 0.214285714,
          "PromotionName": "",
          "LayoutInfo": [
            {
              "MultiPublishString": "Ｗ親",
              "OrderNumSeqNo": 30,
              "Priority": 1,
              "GuideGoodsName": "新潟コシヒカリ",
              "GuideStandardName": "５ｋｇ",
              "MakerName": "マルキユー食品",
              "ThisTimeSupplyPrice": 380,
              "OrderNum": "",
              "PricePattern": "1",
              "EdlpDiv": "0",
              "ReceiptSOrderCode": "",
              "StartOrderCode": "",
              "OrderNum6Digits": "",
              "ItemCode": "",
              "OrderGoodsFlg": "01",
              "PCode": "P1393391"
            }, {
              "MultiPublishString": "Ｗ親",
              "OrderNumSeqNo": 60,
              "Priority": 2,
              "GuideGoodsName": "秋田あきたこまち",
              "GuideStandardName": "５ｋｇ",
              "MakerName": "ピックルスコーポレーション",
              "ThisTimeSupplyPrice": 218,
              "OrderNum": "",
              "PricePattern": "1",
              "EdlpDiv": "0",
              "ReceiptSOrderCode": "",
              "StartOrderCode": "",
              "OrderNum6Digits": "",
              "ItemCode": "",
              "OrderGoodsFlg": "01",
              "PCode": "P2197006"
            }
          ],
          "ImageInfo": [
            {
              "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_600/P2665011A_01.png?20250226111354",
              "ShowSeq": 1
            },
            {
              "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_600/P2665011B_01.png?20250226111354",
              "ShowSeq": 2
            },
            {
              "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_600/P2665011C_01.png?20250226111354",
              "ShowSeq": 3
            }
          ]
        },]
      }
    };
  }
};

const getPage = (pageId: number) => {
  //2023300, ハピデリ, いばらき, 001ページ
  if (pageId === 2542103) {
    return {
      "status": "ok",
      "message": "処理完了",
      "result": {
        "obj": {
          "PageInfo": {
            "PageID": 2542103,
            "PageNum": 1,
            "TemplateName": "食品（５×７）",
            "PositionX": 0.0,
            "PositionY": 0.0,
            "SizeW": 257.5,
            "SizeH": 350.0,
            "DivX": 5,
            "DivY": 7,
            "SectionInfo": [
              {
                "SectionID": 2603682,
                "PositionX": 0.0,
                "PositionY": 0.0,
                "SizeW": 1.0,
                "SizeH": 1.0,
                "DivX": 5,
                "DivY": 7,
                "KomaInfo": [
                  {
                    "KomaID": 43983738,
                    "PositionX": 0.6,
                    "PositionY": 0.0,
                    "SizeW": 0.3,
                    "SizeH": 0.214285714,
                    "PromotionName": "",
                    "LayoutInfo": [
                      {
                        "MultiPublishString": isUpdated ? "Ｗ子" : "Ｗ親",
                        "OrderNumSeqNo": 30,
                        "Priority": 1,
                        "GuideGoodsName": "新潟コシヒカリ",
                        "GuideStandardName": "５ｋｇ",
                        "MakerName": "ＪＡ新潟かがやき・えちご中越産",
                        "ThisTimeSupplyPrice": 1980,
                        "OrderNum": "",
                        "PricePattern": "2",
                        "EdlpDiv": "0",
                        "ReceiptSOrderCode": "",
                        "StartOrderCode": "",
                        "OrderNum6Digits": "",
                        "ItemCode": "",
                        "OrderGoodsFlg": "01",
                        "PCode": "P1393391"
                      }, {
                        "MultiPublishString": isUpdated ? "Ｗ子" : "Ｗ親",
                        "OrderNumSeqNo": 50,
                        "Priority": 2,
                        "GuideGoodsName": "秋田あきたこまち",
                        "GuideStandardName": "５ｋｇ",
                        "MakerName": "ＪＡ秋田おばこ・秋田なまはげ産",
                        "ThisTimeSupplyPrice": 1680,
                        "OrderNum": "",
                        "PricePattern": "2",
                        "EdlpDiv": "0",
                        "ReceiptSOrderCode": "",
                        "StartOrderCode": "",
                        "OrderNum6Digits": "",
                        "ItemCode": "",
                        "OrderGoodsFlg": "01",
                        "PCode": "P1390899"
                      }
                    ],
                    "ImageInfo": [
                      {
                        "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_612/P1393391A_10.png?20250226111236",
                        "ShowSeq": 1
                      }
                    ]
                  },
                ]
              }
            ]
          }
        }
      }
    };
  }
  return {
    "status": "ok",
    "message": "処理完了",
    "result": {
      "obj": {
        "PageInfo": {
          "PageID": 2542110,
          "PageNum": 2,
          "TemplateName": "食品（５×７）",
          "PositionX": 0.0,
          "PositionY": 0.0,
          "SizeW": 257.5,
          "SizeH": 350.0,
          "DivX": 5,
          "DivY": 7,
          "SectionInfo": [
            {
              "SectionID": 2603689,
              "PositionX": 0.0,
              "PositionY": 0.0,
              "SizeW": 1.0,
              "SizeH": 1.0,
              "DivX": 5,
              "DivY": 7,
              "KomaInfo": [
                {
                  "KomaID": 43983808,
                  "PositionX": 0.5,
                  "PositionY": 0.0,
                  "SizeW": 0.25,
                  "SizeH": 0.214285714,
                  "PromotionName": "",
                  "LayoutInfo": [
                    {
                      "MultiPublishString": isUpdated ? "Ｗ親" : "Ｗ子",
                      "OrderNumSeqNo": 30,
                      "Priority": 1,
                      "GuideGoodsName": "新潟コシヒカリ",
                      "GuideStandardName": "５ｋｇ",
                      "MakerName": "マルキユー食品",
                      "ThisTimeSupplyPrice": 380,
                      "OrderNum": "",
                      "PricePattern": "1",
                      "EdlpDiv": "0",
                      "ReceiptSOrderCode": "",
                      "StartOrderCode": "",
                      "OrderNum6Digits": "",
                      "ItemCode": "",
                      "OrderGoodsFlg": "01",
                      "PCode": "P1393391"
                    }, {
                      "MultiPublishString": isUpdated ? "Ｗ親" : "Ｗ子",
                      "OrderNumSeqNo": 60,
                      "Priority": 2,
                      "GuideGoodsName": "秋田あきたこまち",
                      "GuideStandardName": "５ｋｇ",
                      "MakerName": "ピックルスコーポレーション",
                      "ThisTimeSupplyPrice": 218,
                      "OrderNum": "",
                      "PricePattern": "1",
                      "EdlpDiv": "0",
                      "ReceiptSOrderCode": "",
                      "StartOrderCode": "",
                      "OrderNum6Digits": "",
                      "ItemCode": "",
                      "OrderGoodsFlg": "01",
                      "PCode": "P2197006"
                    }
                  ],
                  "ImageInfo": [
                    {
                      "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_600/P2665011A_01.png?20250226111354",
                      "ShowSeq": 1
                    },
                    {
                      "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_600/P2665011B_01.png?20250226111354",
                      "ShowSeq": 2
                    },
                    {
                      "ImagePath": "http://127.0.0.1:8083/N_PEACE/file/image//IMG_600/P2665011C_01.png?20250226111354",
                      "ShowSeq": 3
                    }
                  ]
                },
              ]
            }
          ]
        }
      }
    }
  };
};
